(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsListHelpfulResourcesController', CmsListHelpfulResourcesController);

  /* ngInject */
  function CmsListHelpfulResourcesController(Flash, cmsHelpfulResourceService, formErrorsService, publishedStatuses, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.getHelpfulResources = getHelpfulResources;
    vm.helpfulResources = [];
    vm.publishedStatuses = publishedStatuses;
    vm.publishedStatusFilter = 'published';

    vm.activate();

    function activate() {
      vm.getHelpfulResources();
    }

    function getHelpfulResources() {
      cmsHelpfulResourceService(sessionService.getAuthToken()).query(response => vm.helpfulResources = response);
    }
  }
})();
